module.exports = __webpack_public_path__ + "static/media/tiktok.2a46d1f3.jpg";